'use strict';

var GridToolbarSystemStatusFlightSentController = function GridToolbarSystemStatusFlightSentController() {};
GridToolbarSystemStatusFlightSentController.$inject = [];
module.exports = GridToolbarSystemStatusFlightSentController;